import { render, staticRenderFns } from "./shopHouseDetail.vue?vue&type=template&id=631dc9c6&scoped=true&"
import script from "./shopHouseDetail.vue?vue&type=script&lang=js&"
export * from "./shopHouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./shopHouseDetail.vue?vue&type=style&index=0&id=631dc9c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631dc9c6",
  null
  
)

export default component.exports